<template>
  <div class="ws-info-text">
    {{_value}}
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: null,
    },
    getText: {
      type: Function,
      default: null,
    },
  },
  computed: {
    _value() {
      if (this.getText) return this.getText(this.value)
      return this.value
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/ws-info-text.scss";
</style>